__webpack_require__.p = "/mbti-react/";